import { SvgIcon } from '@mui/material';
import { observer } from 'mobx-react';
import { Component } from 'react';

class IconeJulgarPlanilha extends Component {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
                    clipPath="url(#b)"
                    transform="matrix(.70247 0 0 .70247 -.619 -.58)"
                />
                <text
                    style={{ lineHeight: '1.25' }}
                    x="14.659"
                    y="23.626"
                    fontWeight="400"
                    fontSize="12.535"
                    letterSpacing="0"
                    wordSpacing="0"
                    fontFamily="sans-serif"
                    strokeWidth="1.567"
                >
                    <tspan
                        x="14.659"
                        y="23.626"
                        fontWeight="600"
                        fontSize="14.624"
                        fontFamily="FreeSans"
                    >
                        P
                    </tspan>
                </text>
            </SvgIcon>
        );
    }
}

export default observer(IconeJulgarPlanilha);
